import { TABLE_EVENT } from 'constants/table';
import { EventSubscription, Observer } from 'utils/eventObserver';

export type TableEventPayload = {
    rowIndex: any;
    event: any;
};

export type TableEventSubscriptionTypes = {
    subscribe: (
        EVENT: TABLE_EVENT,
        observer: Observer<TableEventPayload>,
    ) => void;
    unsubscribe: (
        EVENT: TABLE_EVENT,
        observer: Observer<TableEventPayload>,
    ) => void;
};

export const tableSubscriptions: {
    [key: string]: EventSubscription<TableEventPayload>;
} = {
    ROW_CHANGED: new EventSubscription(TABLE_EVENT.ROW_CHANGED),
    ROW_CLICKED: new EventSubscription(TABLE_EVENT.ROW_CLICKED),
};

const subscribe = (
    EVENT: TABLE_EVENT,
    observer: Observer<TableEventPayload>,
): void => {
    tableSubscriptions[EVENT].subscribe(observer);
};

const unsubscribe = (
    EVENT: TABLE_EVENT,
    observer: Observer<TableEventPayload>,
): void => {
    tableSubscriptions[EVENT].unsubscribe(observer);
};

export const eventSubscription = {
    subscribe,
    unsubscribe,
};
